module.exports = __webpack_public_path__ + "img/group_outline.10348536.svg";